import { Step, StepEngineStepGroup } from 'app/modules/step-engine/utils/step-engine-constants';
import { getKeyByValue } from 'app/modules/step-engine/utils/step-engine-methods';
import { stickyStepsMapper } from 'app/modules/sticky-recap/utils/sticky-mappers';
import { STEP_PREFIX } from 'app/shared/constants/constants';
import { IRootState } from 'app/shared/reducers';
import { isEmptyArray, isEmptyObject, isEmptyString } from 'app/shared/util/method-util';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Question from './components/question';
import './sticky-recap.scss';

interface IStickyRecapProps {
    questions?: any[];
}

const StickyRecap = (props: IStickyRecapProps) => {
    const { questions } = props || {};
    const { cmsContent } = useSelector((state: IRootState) => state.cms);
    const { stepData, declarationGlobalData, stepToScroll } = useSelector((state: IRootState) => state.stepEngine);

    const showIndex = (step) => {
        if (isEmptyObject(declarationGlobalData)) {
            return true;
        }
        if (declarationGlobalData[step] === undefined) {
            return true;
        }
        if (typeof declarationGlobalData[step] === 'string' && isEmptyString(declarationGlobalData[step])) {
            return true;
        }
        if (typeof declarationGlobalData[step] === 'object' && isEmptyObject(declarationGlobalData[step])) {
            return true;
        }
        if (Array.isArray(declarationGlobalData[step]) && isEmptyArray(declarationGlobalData[step])) {
            return true;
        }
        return false;
    }

    const concatArrayElements = (array: string[]) => {
        let result = '';
        let index = 0;
        for (index = 0; index < array.length; index++) {
            if (index === 0)
                result = result.concat(array[index]["label"]);
            else
                if (index < 2)
                    result = result.concat(", " + array[index]["label"]);
        }
        if (array.length <= 2)
            return (
                <>
                    {result}
                </>
            )
        else
            return (
                <>
                    {result}
                    <div className='stickyResponseBadge'>
                        {
                            "+" + (array.length - 2).toString()
                        }
                    </div>
                </>
            )
    }

    const showResponse = (step) => {
        if (declarationGlobalData !== undefined && declarationGlobalData[step] !== undefined) {
            return stickyStepsMapper(getKeyByValue(Step, step), cmsContent, declarationGlobalData);
        }

        return "";
    };

    const focusStepToUpdate = (stepkey) => {
        const elementToScroll: HTMLElement = document.getElementById(STEP_PREFIX + stepkey);
        window.scrollTo({ top: elementToScroll.offsetTop, behavior: 'smooth' });
        elementToScroll.classList.toggle("hide-annimation", true);
        new Promise((resolve) => setTimeout(resolve, 1000))
            .then(res => {
                document.getElementById(STEP_PREFIX + stepkey).classList.replace("hide-annimation", "show-annimation")
            })
    }

    useEffect(() => {
        if (questions?.length > 1 && stepData.lastEditStep !== Step.DECLARATION_SUMMARY && stepData.currentStepGroup === StepEngineStepGroup.COVERAGE && !stepToScroll) {
            const elementToScroll: HTMLElement = document.getElementById(STEP_PREFIX + questions?.slice(-1)[0].props.dataKey);
            const header: HTMLElement = document.getElementById("navBar_desktop");
            const footer: HTMLElement = document.getElementById("footer-container");
            const elementPosition = document.documentElement.scrollHeight - (header.offsetHeight * 2) - footer.offsetHeight - elementToScroll.offsetHeight;
            new Promise((resolve) => setTimeout(resolve, 100))
                .then(res => {
                    document.documentElement.style.scrollBehavior = "smooth";
                    window.scrollTo(0, elementPosition)
                })
        }
    }, [questions, stepData.lastEditStep, stepToScroll])

    return (
        <div className="sticky-recap">
            <div className='sticky-container'>
                <div className='title'>
                    <div className="recap-title">
                        Déclaration de sinistre
                    </div>
                </div>
                <div className='questions'>
                    {questions?.filter(q => cmsContent[q.props.dataKey]?.behaviors?.hideFromRecap !== true).map((componentItem: any, key) => {
                        const { dataKey } = componentItem?.props;
                        return (
                            <React.Fragment key={key}>
                                <Question
                                    index={key}
                                    title={cmsContent[dataKey]?.prismic?.gtmLabel}
                                    response={showResponse(dataKey)}
                                    showIndex={showIndex(dataKey)}
                                    focusStepToUpdate={() => focusStepToUpdate(dataKey)}>
                                </Question>
                                <div className='question-line-separator' />
                            </React.Fragment>
                        );
                    })
                    }
                </div>
            </div>
        </div>
    );
};

export default StickyRecap;